import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICrudService } from 'src/app/domain/ICrudService';
import { API_PATH } from 'src/environments/environment';

export abstract class AbstractCrudService implements ICrudService {
  title = '';
  pluralTitle = '';

  constructor(
    protected httpClient: HttpClient,
    protected relativeUrl: string
  ) {}

  public listAll(filter: {}, customerId?: any): Observable<any> {
    let params = {
      ...{ getRelation: 0, limit: 36, page: 0, filter: '' },
      ...filter,
    };
    return this.httpClient.get<any>(`${API_PATH}${this.relativeUrl}`, {
      params,
    });
  }

  public get(id: string): Observable<Object> {
    return this.httpClient.get<Object>(`${API_PATH}${this.relativeUrl}/${id}`);
  }

  public create(object: Object): Observable<void> {
    return this.httpClient.post<void>(`${API_PATH}${this.relativeUrl}`, object);
  }

  public createWithFormData(formData: FormData): Observable<void> {
    return this.httpClient.post<void>(
      `${API_PATH}${this.relativeUrl}`,
      formData, {
        reportProgress: true,
        responseType: 'json'
      }
    );
  }

  public update(id: string, object: Object): Observable<void> {
    return this.httpClient.put<void>(
      `${API_PATH}${this.relativeUrl}/${id}`,
      object
    );
  }

  public updatePassword(id: string, object: Object): Observable<void> {
    return this.httpClient.put<void>(
      `${API_PATH}${this.relativeUrl}/password/${id}`,
      object
    );
  }

  public updateWithFormData(id: string, formData: FormData): Observable<void> {
    return this.httpClient.put<void>(
      `${API_PATH}${this.relativeUrl}/${id}`,
      formData, {
        reportProgress: true,
        responseType: 'json'
      }
    );
  }

  public delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${API_PATH}${this.relativeUrl}/${id}`);
  }
}
